import { Injectable } from '@angular/core';
import { Observable, combineLatest } from 'rxjs';
import { distinctUntilChanged, map, shareReplay, startWith } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { PermissionService } from './permission.service';
import { PermissionFlags } from '../enums/permissionFlags.enum';
import { SecurityProfileEnum } from '../enums/securityProfile.enum';
import { RolePermissionObjects } from '../shared/constants/rolePermissionObjects.constants';

@Injectable({ providedIn: 'root' })
export class AiAnalystScopeService {
    readonly canAccessAiAnalyst$: Observable<boolean>;
    readonly canUseAiAnalyst$: Observable<boolean>;

    constructor(private authService: AuthService, private permissionService: PermissionService) {
        const enabledChanged$ = this.authService.aiAnalystEnabledChanged$.pipe(startWith(undefined));
        this.canAccessAiAnalyst$ = enabledChanged$.pipe(
            map(() => this.canAccessAiAnalyst),
            distinctUntilChanged(),
            shareReplay({ bufferSize: 1, refCount: true }),
        );
        this.canUseAiAnalyst$ = combineLatest([enabledChanged$, this.permissionService.isLoaded$]).pipe(
            map(() => this.canUseAiAnalyst),
            distinctUntilChanged(),
            shareReplay({ bufferSize: 1, refCount: true }),
        );
    }

    get canAccessAiAnalyst(): boolean {
        return !!this.authService.getCurrentUser()?.isAiAnalystEnabled;
    }

    get canUseAiAnalyst(): boolean {
        if (!this.canAccessAiAnalyst) {
            return false;
        }
        return this.authService.getCurrentUser()?.userType === SecurityProfileEnum.SuperAdmin
            || this.permissionService.hasPermissionFlag(
                RolePermissionObjects.AiAnalystAccess,
                PermissionFlags.ReadMy | PermissionFlags.ReadHierarchy);
    }
}
